import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { ComplaintsProvider } from '../../providers/complaints/complaints';
import { LoginProvider } from '../../providers/login/login';
import { ToastProvider } from '../../providers/toast/toast';
import { ComplaintTabsPage } from '../complaint-tabs/complaint-tabs';
import { MarkCloseModalPage } from '../mark-close-modal/mark-close-modal';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-complaints-details',
  templateUrl: 'complaints-details.html',
})
export class ComplaintsDetailsPage {

  complaint: any;
  comments= [];
  public more: boolean = true;
  activity = true;
  feedback: string;
  permissions: any;
  rate = false;
  comment: string;
  active: boolean = false;
  societySettings = {};
  commonArea: string;
  disableSend = false;
  jobcards: any;
  showJobcard = false;

  constructor(public navCtrl: NavController, public navParams: NavParams,private translate: TranslateService, public complaintsProvider:ComplaintsProvider, public alertCtrl:AlertController, 
    private loginProvider: LoginProvider, private toast: ToastProvider, private modalCtrl: ModalController, private util: UtilService) {
    this.complaint = this.navParams.data.complaint;
    if(typeof this.complaint.data == "string"){
      this.complaint.data = JSON.parse(this.complaint.data);
    }
    complaintsProvider.getComments(this.complaint.id).then(res => {
      this.showComments(res);
    });
    complaintsProvider.getJobCards(this.complaint.id).then(val => {
      if(val && val.cards){
        this.jobcards = val.cards;
      }
    })
    this.loginProvider.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
    this.loginProvider.getSocietySettings().then(val => {
      this.societySettings = val;
    });
    if(this.complaint.constant_society_id){
      this.complaintsProvider.getCommonAreaName(this.complaint.constant_society_id).then(val => {
        if(val)
          this.commonArea = val;
      });
    }
  }

  showComments(res){
    this.comments = res;
    console.log(this.comments);
  }

  public onMore() {
    this.more = !this.more;
  }

  public onActivities(){
    this.activity = true;
  }

  showReopenPrompt(event: any){
    const prompt = this.alertCtrl.create({
      title: 'Re-open complaint',
      message: 'Reason for reopen (optional)',
      inputs: [
        {
          name: 'title'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Ok',
          handler: data => {
            console.log('Saved clicked');
            this.complaint.resident_remarks = data.title;
            this.complaint.status = "Reopen";
            this.updateComplaint();
          }
        }
      ]
    });
    prompt.present();
  }

  public action(event: any){
    console.log(event);
    if(event == "Closed"){
      this.showReopenPrompt(event);
    }else {
      let modal = this.modalCtrl.create(MarkCloseModalPage, {
        data: this.complaint,
        parentPageNav: this.navCtrl
      });
      modal.present();
    }
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }

  onFeedback(data:any, rating){
    console.log("==========");
    console.log(rating);
    this.complaint.resident_remarks = data.title;
    this.onRate(rating);
    this.complaint.status = "Closed";
    console.log(this.complaint);
    this.updateComplaint();
  }

  onRate(index: number){
    if(!this.complaint.rating || +this.complaint.rating == 0){
      console.log(index);
      this.complaint.rating = index +"";
      this.rate = true;
    }
  }

  onComment(){
    console.log(this.comments);
    this.disableSend = true; 
    this.complaintsProvider.addComment(this.comment, this.complaint.id).then(val => {
      if(val.status == "success"){
        let comment = {
          remarks: this.comment,
          created_at: new Date(),
          name: this.complaint.createdBy
        }
        this.comments.unshift(comment);
        this.toast.presentToast("New comment added");
        this.comment = "";
        console.log(this.comments);
      }
      this.disableSend = false;
    }).catch(err => {
      this.disableSend = false;
      this.toast.presentToast("Try after some time");
    });
  }

  updateComplaint(){
    this.complaintsProvider.updateComplaint(this.complaint).then(res => {
      if(res.status == "success"){
        this.navCtrl.push(
          ComplaintTabsPage,
          {index: 0}
        ).then(() =>  {
          this.util.clearNavStack(this.navCtrl);
        });
      } else {
        this.toast.presentToast(res.message);
        if(this.complaint.status=='Closed' || this.complaint.status=='Resolved'){
          this.complaint.status = "Open";
        }else{
          this.complaint.status = "Closed";
        }
      }
    });
  }

  activate(){
    if(this.complaint.img_src){
      this.active = !this.active;
    }
  }

  toggleJobcard(){
    this.showJobcard = !this.showJobcard;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ComplaintsDetailsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/complaints-details/complaints-details.ts